import type { LoginForm } from "@/stores/user"
import { useUserStore } from "@/stores/user"
import type { AxiosResponse } from "@/plugins/axios"
import type { App } from "vue"

export interface Auth {
  user: App.Models.User | null
  login: (form: LoginForm) => Promise<AxiosResponse<{ access_token: string }>>
  loadUser: (force?: boolean) => Promise<void>
  logout: () => Promise<void>
  impersonate: (userId: number) => Promise<AxiosResponse<{ access_token: string }>>
  stopImpersonating: () => Promise<AxiosResponse<{ access_token: string }>>
  loggedIn: boolean
  isGuest: () => boolean
  isAdmin: () => boolean
  isApplicant: () => boolean
  isCompany: () => boolean
}

export const $auth: Auth = {
  get user(): App.Models.User | null {
    const userStore = useUserStore()
    return userStore.user
  },
  set user(user: App.Models.User | null) {
    const userStore = useUserStore()
    userStore.user = user
  },
  async login(form: LoginForm) {
    const userStore = useUserStore()
    return await userStore.login(form)
  },
  async loadUser(force: boolean = false) {
    const userStore = useUserStore()
    return await userStore.loadUser(force)
  },
  logout() {
    const userStore = useUserStore()
    return userStore.logout()
  },
  get loggedIn() {
    return !!this.user
  },
  isGuest(): boolean {
    return !this.loggedIn
  },
  isAdmin(): boolean {
    return this.loggedIn && this.user?.type === 'Admin'
  },
  isApplicant(): boolean {
    return this.loggedIn && this.user?.type === 'Applicant'
  },
  isCompany(): boolean {
    return this.loggedIn && this.user?.type === 'Company'
  },
  async impersonate(userId: number) {
    const userStore = useUserStore()
    return await userStore.impersonate(userId)
  },
  async stopImpersonating() {
    const userStore = useUserStore()
    return await userStore.stopImpersonating()
  },
}

export default {
  install(app: App) {
    app.config.globalProperties.$auth = $auth
  }
}
